import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import RedeemSDK from 'sdk/redeem'
import { SaleProgress, BeforeSale } from 'pages/mkt/components'
import { classNames, format } from '@dt/fe-utils'
import { TGroupByProductType } from '@common/enum/mkt.enum'
import './index.scss'

import defaultImg from '@img/mkt/default-redeem.jpg'
interface IProps {
  info: any;
  showSoldNum: boolean;
  onDetail: () => void;
}

const ProductItem: FC<IProps> = (props: IProps) => {
  const { showSoldNum, info, onDetail } = props
  const [statusInfo, setStatusInfo] = useState<any>({})
  const initData = () => {
    setStatusInfo(RedeemSDK.getInfo(info))
  }
  useEffect(() => {
    if (info) {
      initData()
    }
  }, [info])
  const renderTag = (children) => {
    return (
      <div className='person-limit-area'>
        <div className='person-limit'>{children}</div>
      </div>
    )
  }

  const hasSoldOut = statusInfo.status === 2 // 商品售磬
  const startTime = format.toTime(statusInfo.saleStart)
  const endTime = format.toTime(statusInfo.saleEnd)
  const showTimeRange = startTime !== '00:00' || endTime !== '00:00'

  return (
    <>
      <div
        data-cypid='mmgProductItem'
        className='groupBuy-product' onClick={() => onDetail()}
      >
        <div className='top' style={{ backgroundImage: `Url(${info.productImg || defaultImg})` }} />
        <div className='bottom'>
          <div className='info-area'>
            <div className={`info-name${hasSoldOut ? ' info-name--disabled' : ''}`}>{info.productName}</div>
            <div className='info-tag'>
              {info.productType && info.productType !== TGroupByProductType.coupons ? renderTag(<span>{i18n.t(`mkt.groupBuy.${info.productType}`)}</span>) : null}
              {statusInfo.expired > 0 && statusInfo.expired <= 3 && renderTag(<span>{i18n.t('mkt.redeem.someDaysOff', { day: statusInfo.expired })}</span>)}
              {[2, 3, 4].includes(statusInfo.status) && renderTag(<span>{i18n.t('mkt.redeem.endThisRound')}!</span>)}
              {info.personLimit && renderTag(<span>{i18n.t('mkt.groupBuy.singleLimit', { num: info.personLimit })}</span>)}
              {(statusInfo.status === 0 || (hasSoldOut && statusInfo.type === 2) || statusInfo.status === 3) && renderTag(
                <>
                  <span>{i18n.t('mkt.redeem.beforeSale')}</span>
                  <BeforeSale time={statusInfo.cdTime} onEnd={() => { initData() }} />
                </>
              )}
              {statusInfo.status === 0 && renderTag(<span>{i18n.t('mkt.redeem.timeGoingRob', { time: format.toTime(statusInfo.saleStart) })}</span>)}
              {statusInfo.status === 1 && showTimeRange && renderTag(<span>{i18n.t('mkt.redeem.quickGrabOnSale', { start: startTime, end: endTime, symbol: window.bo === 'cn' ? '~' : '-' })}</span>)}
            </div>
            <div className='info-sale'>
              {statusInfo.type === 0
                ? (showSoldNum && <div className='sale-text'>{i18n.t('mkt.redeem.sold')} {statusInfo.allSaleCnt}</div>) : (
                  <>
                    {hasSoldOut
                      ? (
                        <div className='bar-area'>
                          <SaleProgress />
                        </div>
                      ) : (
                        <>
                          <div className='bar-area'>
                            <SaleProgress rate={statusInfo.saleRate} extraText={i18n.t(statusInfo.saleCircle ? `mkt.redeem.${statusInfo.saleCircle}OnlyLeftCnt` : 'mkt.redeem.onlyLeftCnt', { cnt: statusInfo.remainCnt })}></SaleProgress>
                          </div>
                          <div className='sale-text'>
                            {`${i18n.t('mkt.redeem.limitSale')} ${statusInfo.stockCnt}`}
                            {showSoldNum && `, ${i18n.t('mkt.redeem.sold')} ${statusInfo.saleCnt}`}
                          </div>
                        </>
                      )}
                  </>)}
            </div>
          </div>
          <div className='price-area'>
            {
              info.tradeType === 'money' ? (
                <div className={`price${hasSoldOut ? ' price--disabled' : ''}`}>
                  <span className='text'>{format.toCurrency()}</span>
                  <span>{format.toPriceNoCurrency(info.productMoney)}</span>
                </div>
              ) : (
                <div className={`price${hasSoldOut ? ' price--disabled' : ''}`}>
                  <span>{info.productIntegral}</span>
                  <span className='text'>{i18n.t('mkt.common.integral')}</span>
                </div>
              )
            }
            {hasSoldOut && (
              <span className='sold-out'>{i18n.t('mkt.redeem.soldOut')}</span>
            )}
          </div>
        </div>
        {/* {
          statusInfo.status === 1 &&
            <div className='recom-show'>
              <img src={IconRecom} alt='' />
            </div>
        } */}
      </div>
    </>
  )
}

export default observer(ProductItem)
